import './styles.scss';
import DATA from 'utils/data.json';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useState } from 'react';
import { Controller, Pagination } from 'swiper';

import 'swiper/css';
import "swiper/css/thumbs";

const TEACHER_DATA = DATA.teacher;
const LECTURERS_DATA = TEACHER_DATA.lecturers

const Lecturers = () => {
    const [imageSwiper, setImageSwiper] = useState(null);
    const [infoSwiper, setInfoSwiper] = useState(null);

    return (
        <div className="lecturers-block">
            <div className='title-wrapper container'>
                <img src={LECTURERS_DATA.icon} className="icon" alt='' />
                <p>{LECTURERS_DATA.title}</p>
            </div>
            <div className='content container'>
                <Swiper
                    slidesPerView={3}
                    spaceBetween={0}
                    loop={true}
                    loopedSlides={4}
                    centeredSlides
                    className='slide'
                    slideToClickedSlide={true}
                    onSwiper={setImageSwiper}
                    modules={[Controller]}
                    controller={{ control: infoSwiper && !infoSwiper.destroyed ? infoSwiper : null }} 
                >
                    {LECTURERS_DATA.list.map((item, index) => {
                        return (
                            <SwiperSlide className='item' key={index}>
                                <img src={item.image} alt='' className='image' />
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    loopedSlides={4}
                    centeredSlides
                    className='slide-info'
                    onSwiper={setInfoSwiper}
                    modules={[Controller, Pagination]}
                    controller={{ control: imageSwiper && !imageSwiper.destroyed ? imageSwiper : null }} 
                    pagination={{
                        clickable: true,
                        renderBullet: function(index, className) {
                            return '<span class="' + className + '"><img class="pagination-bullet"/></span>';
                        }
                    }}
                >
                    {LECTURERS_DATA.list.map((item, index) => {
                        return (
                            <SwiperSlide className='item' key={index}>
                                <p className='item__name'>{item.name}</p>
                                <p className='item__position'>{item.position}</p>
                                <p className='item__desc'>{item.desc}</p>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
        </div>
    )
}

export default Lecturers;